import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import { Container, Label, Input, IconContainer, Value, ValueContainer } from './styles';
import Tooltip from '@mui/material/Tooltip';

const Props = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  marginBottom: PropTypes.number,
};

const DEFAULT_PROPS = {
  marginBottom: 0,
};

export default function ProfileField({ label, icon, value, marginBottom }) {
  return (
    <Container marginBottom={marginBottom}>
      <Label>{label}</Label>
      <Input>
        <IconContainer>
          <Icon name={icon} />
        </IconContainer>
        <Tooltip title={value} placement="top">
          <ValueContainer>
            <Value>{value}</Value>
          </ValueContainer>
        </Tooltip>
      </Input>
    </Container>
  );
}

ProfileField.propTypes = Props;
ProfileField.defaultProps = DEFAULT_PROPS;
